<template>
  <div id="view2" class="lv1Text">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="background-color:#fff;padding:20px 0;">
      <div class="container">
        <el-row :gutter="20">
          <el-col :span="7">
            <div style="border:1px solid #ddd;padding:10px;">
              <el-image
                style="width: 315px; height: 319px"
                :src="serve  + data.images"
                fit="fill"
              ></el-image>
            </div>
          </el-col>
          <el-col :span="17" v-if="type==0">
            <div>
              <el-row>
                <el-col :span="14">
                  <div style="font-size:20px">
                    {{data.title}}
                    <span
                      class="discount"
                      v-if="data.discount_num>0"
                    >{{data.discount_num}}折优惠</span>
                  </div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv0Text" style="font-size:30px">&yen;{{data.selling_price}}</div>
                  <div class="lv3Text">现价</div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv3Text" style="font-size:30px">
                    <s>&yen;{{data.original_price}}</s>
                  </div>
                  <div class="lv3Text">市场价</div>
                </el-col>
              </el-row>
            </div>
            <div class="lv2Text">
              <span class="lv3Text">浏览次数：</span>
              <span>{{data.views}}</span>
              <span class="lv3Text" style="margin-left:10px">销量：</span>
              <span>{{data.sales}}</span>
            </div>
            <div class="box">
              <div style="padding:10px;">
                <div style="padding: 10px 0">
                  <span>现价:</span>
                  <span
                    class="lv0Text"
                    style="font-size:20px;margin-left:10px"
                  >&yen;{{data.selling_price}}</span>
                  <span class="lv3Text" style="margin-left:10px">
                    <s>&yen;{{data.original_price}}</s>
                  </span>
                </div>
                <div style="padding: 10px 0" class="lv3Text">
                  <i class="fas fa-check-circle"></i> 服务承诺
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 正品保证
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 极速发货
                </div>
              </div>
            </div>

            <div style="margin:20px 0;">
              <el-input-number v-model="number" :min="1" :max="99" label="数量：" size="medium"></el-input-number>
              <span class="lv3Text" v-if="info.inventory">(库存：{{info.inventory}})</span>
            </div>
            <div>
              <el-button class="btn" @click="add">加入购物车</el-button>
              <el-button type="primary" class="btn" @click="buy">立即购买</el-button>
              <el-button
                plain
                size="mini"
                class="cl-btn"
                @click="addFv"
                v-if="isFav==false&&$store.state.isLogin==true"
              >
                <i class="fas fa-star"></i>
                <div>收藏</div>
              </el-button>
              <el-button
                plain
                size="mini"
                class="cl-btn active"
                @click="cancelFv"
                v-if="isFav==true&&$store.state.isLogin==true"
              >
                <i class="fas fa-star"></i>
                <div>已收藏</div>
              </el-button>
            </div>
          </el-col>
          <el-col :span="17" v-if="type==1">
            <div>
              技术服务
              <div>
                <el-button
                  plain
                  size="mini"
                  style="float:right"
                  @click="addFv"
                  v-if="isFav==false&&$store.state.isLogin==true"
                >
                  <i class="fas fa-star" style="margin-right:5px;"></i>收藏
                </el-button>
                <el-button
                  plain
                  size="mini"
                  style="float:right"
                  @click="cancelFv"
                  v-if="isFav==true&&$store.state.isLogin==true"
                >
                  <i class="fas fa-star" style="margin-right:5px;"></i>已收藏
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container" style="margin-top:20px;">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情">
                <div class="lv2Text">
                  <el-row :gutter="40">
                    <el-col :span="12">
                      <div v-if="info.brand" class="tp1">
                        <span class="lv3Text">品牌：</span>
                        {{info.brand}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.item_no" class="tp1">
                        <span class="lv3Text">货号：</span>
                        {{info.item_no}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.origin" class="tp1">
                        <span class="lv3Text">产地：</span>
                        {{info.origin}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.leadtime" class="tp1">
                        <span class="lv3Text">货期：</span>
                        {{info.leadtime==0?'现货':info.leadtime+"天"}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.specification" class="tp1">
                        <span class="lv3Text">规格：</span>
                        {{info.specification}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.uses" class="tp1">
                        <span class="lv3Text">应用：</span>
                        {{info.uses}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.molecular" class="tp1">
                        <span class="lv3Text">分子式：</span>
                        {{info.molecular}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.formula" class="tp1">
                        <span class="lv3Text">分子量：</span>
                        {{info.formula}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.CAS" class="tp1">
                        <span class="lv3Text">CAS：</span>
                        {{info.CAS}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.host" class="tp1">
                        <span class="lv3Text">宿主：</span>
                        {{info.host}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.reaction_species" class="tp1">
                        <span class="lv3Text">反应种属：</span>
                        {{info.reaction_species}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.antigen_info" class="tp1">
                        <span class="lv3Text">抗原信息：</span>
                        {{info.antigen_info}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.belong" class="tp1">
                        <span class="lv3Text">种属：</span>
                        {{info.belong}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.animal_age" class="tp1">
                        <span class="lv3Text">动物年龄：</span>
                        {{info.animal_age}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.grade" class="tp1">
                        <span class="lv3Text">等级：</span>
                        {{info.grade}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.editor" class="tp1">
                        <span class="lv3Text">主编：</span>
                        {{info.editor}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.editor" class="tp1">
                        <span class="lv3Text">主编：</span>
                        {{info.editor}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.press" class="tp1">
                        <span class="lv3Text">出版社：</span>
                        {{info.press}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.press_time" class="tp1">
                        <span class="lv3Text">图书出版时间：</span>
                        {{info.press_time}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.sell_unit" class="tp1">
                        <span class="lv3Text">出售规格：</span>
                        {{info.sell_unit}}
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-if="info.sell_unit" class="tp1">
                        <span class="lv3Text">出售规格：</span>
                        {{info.sell_unit}}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div></div>
              </el-tab-pane>
              <el-tab-pane label="评价" style="padding: 20px 10px;">
                <div v-if="!empty">
                  <div v-for="(item,index) of comments" :key="index" class="comment-item">
                    <div class="clear top1">
                      <div class="clear-item">
                        <img :src="item.headImg" class="avatar">
                      </div>
                      <div class="clear-item lv3Text" style="margin:0 10px;">{{item.nickname}}</div>
                      <div class="clear-item" v-if="item.rank">
                        <el-rate
                          class="ra"
                          disabled
                          :value="_.toInteger(item.rank)"
                          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        ></el-rate>
                      </div>
                    </div>
                    <el-row>
                      <el-col :span="20" :offset="4">
                        <div class="lv2Text">{{item.content}}</div>
                        <div
                          class="lv3Text"
                          style="font-size:12px;margin:10px 0 5px 0;"
                        >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="pager" align="center">
                    <el-pagination
                    hide-on-single-page
                      @current-change="pageChange"
                      background
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="10"
                    ></el-pagination>
                  </div>
                </div>
                <div v-else>
                  <div class="lv3Text" style="padding:30px 0;text-align:center">暂无评价</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="hot" align="center">
            <div class="t2">热销榜</div>
            <div v-for="(item,index) in hot" :key="index" class="hot-item">
              <img :src="serve + '/'+item.images" class="cover2">
              <router-link :to="'/view?id='+item.id">
                <div style="margin:10px 0;" class="title">
                  {{
                  _.truncate(item.title, {
                  'length': 15,
                  })
                  }}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      isFav: false,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: {},
      number: 1,
      page: 1,
      comments: {},
      total: 0,
      hot: {},
      empty: true,
      type: "",
      info: {}
    };
  },
  created() {
    this.initData();
  },
  methods: {
    cancelFv() {
      this.axios
        .get(this.serve + "/member/cancel_collect", {
          params: {
            id: this.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = false;
          }
        });
    },
    addFv() {
      this.axios
        .get(this.serve + "/member/add_collect", {
          params: {
            id: this.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = true;
          }
        });
    },
    to(address) {
      window.location.href = address;
    },
    add() {
      if (this.$store.state.isLogin) {
        this.axios
          .get(this.serve + "/member/add_car", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token"),
              id: this.id,
              number: this.number
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message("商品已加入购物车");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.$router.push("/login");
      }
    },
    buy() {
      var json = {
        p_id: this.data.id,
        title: this.data.title,
        item_no: this.data.item_no,
        number: this.number,
        price: this.data.discount_price,
        images: this.data.images
      };
      this.$router.push({
        path: "/user/order3",
        query: { cart: JSON.stringify([json]) }
      });
    },
    pageChange(v) {
      this.page = v;
      this.axios
        .get(this.serve + "/get_product_comment", {
          params: {
            product_id: this.data.id,
            page: this.page
          }
        })
        .then(res => {
          this.comments = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/member/has_collect", {
          params: {
            id: this.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data == "true") {
            this.isFav = true;
          }
        });

      this.axios
        .get(this.serve + "/get_product_info", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.type = res.data.type;
          this.data = res.data.info;
          this.info = res.data.detail;
          _.forEach(this.info, function(value, key) {
          });
          this.hot = res.data.hot;
          this.axios
            .get(this.serve + "/get_product_comment", {
              params: {
                product_id: this.data.id,
                page: this.page
              }
            })
            .then(res => {
              if (res.data.msg == "搜索结果为空") {
                this.empty = true;
              } else {
                this.empty = false;
                this.comments = res.data.data.results;
                this.total = res.data.data.total;
              }
            });
        });
    }
  }
};
</script>
<style lang="scss">
#view2 {
  .tp1 {
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 5px;
    margin-bottom: 8px;
  }
  .cl-btn.active {
    color: #e2211c;
    border-color: #e2211c;
  }
  .cl-btn {
    svg {
      margin-bottom: 2px;
    }
    float: right;
    text-align: center;
    width: 50px;
    padding: 5px 0;
  }
  .discount {
    color: #fff;
    background-color: #e2211c;
    display: inline;
    padding: 2px 15px;
    font-size: 12px;
    border-radius: 8px;
    position: relative;
    bottom: 10px;
  }
  .t3 {
    background-color: #eaeaea;
    padding: 10px 0;
    text-align: center;
  }
  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50px;
  }
  .t2 {
    text-align: center;
    padding: 10px 0;
    background-color: #eee;
    margin-bottom: 20px;
  }
  .cover2 {
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .hot {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    .title:hover {
      text-decoration: underline;
    }
  }
  .hot-item {
    width: 90%;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }
  .r2 {
    padding-right: 30px;
  }
  .r1 {
    padding: 10px 0;
    border-bottom: 2px dashed #ddd;
  }
  .comment-item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .btn {
    width: 150px;
    margin-right: 50px;
  }
  .box {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    margin-top: 20px;
    width: 80%;
  }
  padding: 0 0 50px 0;
  .cover {
    height: 315px;
    width: 315px;
    background-position: center;
    background-size: 100% auto;
  }
}
</style>